<template>
  <partner-card
    :logo-src="partner.mainImage"
    :img-src="partner.backgroundImage"
    :title="partner.name"
    :subtitle="partner.descriptionShort"
  >
    <div class="d-flex flex-column">
      <ul class="tags-container mb-4 px-0">
        <li class="tag" role="region" aria-label="Nazwa partnera">
          <v-icon class="mr-4">mdi-home</v-icon>

          <p>{{ address(partner) }}</p>
        </li>

        <li v-if="partner.phoneNumber" class="tag" role="region" aria-label="Numer telefonu">
          <v-icon mr-4>mdi-phone</v-icon>

          <p>{{ partner.phoneNumber }}</p>
        </li>

        <li v-if="partner.open" class="tag" role="region" aria-label="Godziny otwarcia">
          <v-icon mr-4>mdi-timer</v-icon>

          <p>{{ partner.open }}</p>
        </li>
      </ul>

      <v-btn large outlined elevation="0" color="primary" @click="goToDetails">Zobacz partnera</v-btn>
    </div>
  </partner-card>
</template>

<script>
import PartnerCard from '@/components/base/PartnerCard';
import { address } from '@witkac/kartamiejska-shared';

import { imagesMixin } from '@/mixins/images';

// @vuese
// Karta partnera
// @group Cards
export default {
  components: { PartnerCard },
  mixins: [imagesMixin],
  props: {
    // Obiekt partnera do wyświetlenia
    partner: {
      type: Object,
      required: true
    }
  },
  methods: {
    // @vuese
    // Pokaż szczegóły
    goToDetails() {
      this.$router.push({
        name: 'partnerDetails',
        params: { id: this.partner.id }
      });
    },
    // @vuese
    // Filtr adresu
    address
  }
};
</script>
